import lodash from 'lodash';

const hyphenToCamelCase = (str) => {
   if (!lodash.isString(str)) {
      throw new TypeError('Invalid argument type. Must be string.');
   }

   return str.replace(/-([a-z])/g, (g) => {
      return g[1].toUpperCase();
   });
};


export default {
   hyphenToCamelCase,
};
